export const ShopifyPlan = {
    ShopifyPlus: 'Shopify Plus',
    BasicAppDevelopment: 'Basic App Development',
    Basic: 'Basic',
    Advanced: 'Advanced',
    Shopify: 'Shopify',
    DeveloperPreview: 'Developer Preview',
    PauseAndBuild: 'Pause and Build',
    ShopifyPlusPartnerSandbox: 'Shopify Plus Partner Sandbox',
    PlusTrial: 'Plus Trial',
    Frozen: 'Frozen',
    Development: 'Development',
    Staff: 'Staff',
    StaffBusiness: 'Staff Business',
    ShopifyStarter: 'Shopify Starter',
    Cancelled: 'Cancelled',
    OpenLearning: 'Open Learning',
    Custom: 'Custom',
    ShopifyAlumni: 'Shopify Alumni',
    Trial: 'Trial',
    Grow: 'Grow',
    ShopifyPlusAppDevelopment: 'Shopify Plus App Development',
    AdvancedAppDevelopment: 'Advanced App Development',
    GrowAppDevelopment: 'Grow App Development',
};
//# sourceMappingURL=shopifyPlans.js.map